import { useState } from "react"

export const useColor = () => {
  const [companyTheme, setCompanyTheme] = useState({
    first: "#f48120",
    second: "#ffbf73",
  })

  return { companyTheme }
}
